import React, { useRef, useEffect } from 'react';
import './Drawer.css';

const Drawer = ({ isOpen, onClose, title, children, width }) => {
  const drawerRef = useRef(null);

  // Close on ESC key
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  // Prevent background scroll when open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleOverlayClick = (event) => {
    if (drawerRef.current && !drawerRef.current.contains(event.target)) {
      onClose();
    }
  };

  // Only set width inline if provided
  const asideProps = {
    className: 'drawer-panel',
    ref: drawerRef,
    tabIndex: -1,
    ...(width ? { style: { width } } : {})
  };

  return (
    <div className="drawer-overlay" onClick={handleOverlayClick}>
      <aside {...asideProps}>
        <div className="drawer-header">
          <h2 className="drawer-title">{title}</h2>
          <button className="drawer-close" onClick={onClose} aria-label="Close drawer">
            &times;
          </button>
        </div>
        <div className="drawer-divider"></div>
        <div className="drawer-body">{children}</div>
      </aside>
    </div>
  );
};

export default Drawer; 